module.exports = __webpack_public_path__ + "static/media/enroll.d5d7b458.svg";